import { render, staticRenderFns } from "./vol.vue?vue&type=template&id=25e82550&scoped=true"
import script from "./vol.vue?vue&type=script&lang=js"
export * from "./vol.vue?vue&type=script&lang=js"
import style0 from "./vol.vue?vue&type=style&index=0&id=25e82550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e82550",
  null
  
)

export default component.exports